import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

  const variants = {
    hidden: { opacity: 0, y: -20 }, // Initial state: invisible and slightly shifted upward
    visible: { opacity: 1, y: 0 }, // Final state: fully visible in position
    exit: { opacity: 0, y: -20 }   // State when removed
  };
  const hoverEffect = {
    whileHover: { scale: 1.1, color: "#f39c12" }, // Slight scale-up and color change
  };

  // Fade-in animation for navbar on load
  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8, ease: "easeOut" } },
  };

  // Handle mobile menu toggle
  const handleToggle = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setIsServicesDropdownOpen(false);
  };

  // React Router owns navigation; this control only opens the services menu.
  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  // Close menu on window resize (for responsiveness)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(false);
        setIsServicesDropdownOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  //{pageScrollVariants}
  return (
    <motion.nav
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      variants={variants}
      initial="hidden"
      animate="visible"
      {...hoverEffect}
    >
      <div className="container">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" onClick={handleToggle}>
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <RouterLink className="navbar-brand page-scroll" to="/" onClick={closeMenu}>
            EXIMON
          </RouterLink>
        </div>

        {/* Navbar links (desktop) */}
        <div className={`navbar-collapse ${isOpen ? "in" : "collapse"}`}>
          <ul className="nav navbar-nav navbar-right">
                                {/* <li><ScrollLink to="features" smooth={true} duration={1000} offset={-70} className="page-scroll" onClick={closeMenu}>Features</ScrollLink></li> */}
<li>
<RouterLink to="/features/" onClick={closeMenu}>
  Features
</RouterLink>
</li>
                    <li><RouterLink to="/about/" onClick={closeMenu}>About us</RouterLink></li>
     {/* <li>
      <RouterLink to="/" onClick={() => {
  closeMenu();
  setTimeout(() => {
    document.getElementById("portfolio")?.scrollIntoView({ behavior: "smooth" });
  }, 50);
}}>
  Gallery
</RouterLink>
</li>
<li>
<RouterLink to="/" onClick={() => {
  closeMenu();
  setTimeout(() => {
    document.getElementById("testimonials")?.scrollIntoView({ behavior: "smooth" });
  }, 50);
}}>
  Testimonials
</RouterLink>
</li>
<li>
<RouterLink to="/" onClick={() => {
  closeMenu();
  setTimeout(() => {
    document.getElementById("team")?.scrollIntoView({ behavior: "smooth" });
  }, 50);
}}>
  Team
</RouterLink>
</li> */}
<li><RouterLink to="/gallery/" onClick={closeMenu}>Gallery</RouterLink></li>
<li><RouterLink to="/testimonials/" onClick={closeMenu}>Testimonials</RouterLink></li>
<li><RouterLink to="/team/" onClick={closeMenu}>Team</RouterLink></li>

            {/* Services Dropdown */}
            <li className={`dropdown ${isServicesDropdownOpen ? "open" : ""}`}>
              <div className="services-nav-link" onClick={toggleServicesDropdown}>
                <button type="button" className="services-nav-trigger" aria-expanded={isServicesDropdownOpen}>
                  Services
                </button>
                <button type="button" className="dropdown-toggle" aria-label="Open services menu">
                  <b className="caret"></b>
                </button>
              </div>
              <AnimatePresence>
                {isServicesDropdownOpen && (
                  <motion.ul
                    className="dropdown-menu"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    variants={fadeInVariants}

                  >

                    <li><RouterLink to="/services/" onClick={closeMenu}>EMSS (for Importers Exporters)</RouterLink></li>
                    <li><RouterLink to="/icligm/" onClick={closeMenu}>ICLIGM (for Maritime Shipping companies)</RouterLink></li>
                    <li><RouterLink to="/icl-chat/" onClick={closeMenu}>ICL ChatBot (GenAI / ML)</RouterLink></li>
                    <li><RouterLink to="/icl-react/" onClick={closeMenu}>ICL Reacts (Mobile app)</RouterLink></li>

                  </motion.ul>
                )}
              </AnimatePresence>
            </li>

            <li><RouterLink to="/contact/" onClick={closeMenu}>Contact</RouterLink></li>

          </ul>
        </div>
      </div>
    </motion.nav>
  );
};
